import passwordRules from "@/utils/validatePassword";

/**
 * Reference: https://github.com/wearebraid/vue-formulate-i18n/blob/master/src/locales/en.js
 * This is an object of functions that each produce valid responses. There's no
 * need for these to be 1-1 with english, feel free to change the wording or
 * use/not use any of the variables available in the object or the
 * arguments for the message to make the most sense in your language and culture.
 *
 * The validation context object includes the following properties:
 * {
 *   args        // Array of rule arguments: between:5,10 (args are ['5', '10'])
 *   name:       // The validation name to be used
 *   value:      // The value of the field (do not mutate!),
 *   vm: the     // FormulateInput instance this belongs to,
 *   formValues: // If wrapped in a FormulateForm, the value of other form fields.
 * }
 */
const localizedValidationMessages = {
  passwordHasLength: () =>
    `Password must be at least ${passwordRules.requiredPasswordLength} characters long.`,
  passwordHasNumber: () =>
    `Password must contain at least ${passwordRules.requiredNumbers} number${
      passwordRules.requiredNumbers > 1 ? "s" : ""
    }.`,
  passwordHasSpecial: () =>
    `Password must contain at least ${
      passwordRules.requiredSpecialChars
    } special character${passwordRules.requiredSpecialChars > 1 ? "s" : ""}.`,
  passwordHasUppercase: () =>
    `Password must contain at least ${
      passwordRules.requiredUppercaseChars
    } upper-case character${
      passwordRules.requiredUppercaseChars > 1 ? "s" : ""
    }.`,
  passwordHasLowercase: () =>
    `Password must contain at least ${
      passwordRules.requiredLowercaseChars
    } lower-case character${
      passwordRules.requiredLowercaseChars > 1 ? "s" : ""
    }.`,
  passwordConfirm: () => "Password does not match",
  accepted: () => "You need to accept this to proceed",
  required: () => "This field is required",
};

export default localizedValidationMessages;
